import { render, staticRenderFns } from "./MessageItemV2.vue?vue&type=template&id=7ff11a09&scoped=true"
import script from "./MessageItemV2.vue?vue&type=script&lang=js"
export * from "./MessageItemV2.vue?vue&type=script&lang=js"
import style0 from "./MessageItemV2.vue?vue&type=style&index=0&id=7ff11a09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff11a09",
  null
  
)

export default component.exports